import React from "react";
import { object, bool, func, string } from "prop-types";

import { Icon } from "../../atoms/icon";
import "./member-card.m.css";
import { Linked_In } from "../../../socialIcons/linked_in";
import CloseIcon from "../../atoms/CloseIcon";

export const MemberCard = ({
  member,
  isContactOpen = false,
  openContactId = null,
  onContactToggle,
  ...props
}) => {
  const {
    id = "",
    name = "",
    title = "",
    company = "",
    location = "",
    email = "",
    phone = "",
    profileImage = null,
    linkedinUrl = ""
  } = member || {};

  const isThisContactOpen = openContactId === id;

  const handleViewContactClick = () => {
    if (onContactToggle) {
      onContactToggle(isThisContactOpen ? null : id);
    }
  };

  const handleCloseContact = () => {
    if (onContactToggle) {
      onContactToggle(null);
    }
  };

  return (
    <div styleName="member-card" {...props}>
      <div styleName="member-header">
        <div styleName="member-details">
          <h3 styleName="member-name">{name}</h3>
          <p styleName="member-title">{title}</p>
          <p styleName="member-company">{company}</p>
        </div>

        <div styleName="member-avatar">
          {profileImage ? (
            <img
              src={profileImage}
              alt={name}
              styleName="avatar-image"
            />
          ) : (
            <div styleName="avatar-placeholder">
              <img
                src="/icons/membercard.png"
                alt="Profile placeholder"
                styleName="placeholder-image"
              />
            </div>
          )}
        </div>
      </div>

      <div styleName="member-footer">
        <div styleName="member-contact">
          {/* Contact area is now empty, buttons are positioned absolutely */}
        </div>
      </div>

      {/* View Contact Button - positioned absolutely at bottom left */}
      <button
        styleName="view-contact-button"
        onClick={handleViewContactClick}
      >
        View contact
      </button>

      {/* LinkedIn Icon - positioned absolutely at bottom right */}
      {linkedinUrl && (
        <a
          href={linkedinUrl}
          target="_blank"
          rel="noopener noreferrer"
          styleName="linkedin-link"
        >
          <Linked_In/>
        </a>
      )}

      {/* Contact Details Overlay */}
      {isThisContactOpen && (
        <div styleName="contact-overlay">
          <div styleName="contact-details">
            <div styleName="contact-info-section">
              {location && <p styleName="contact-info-item">{location}</p>}
              {email && <a href={`mailto:${email}`} styleName="contact-info-item">{email}</a>}
              {phone && <a href={`tel:${phone}`} styleName="contact-info-item">{phone}</a>}
            </div>
            <button
              styleName="close-button"
              onClick={handleCloseContact}
              aria-label="Close contact details"
            >
              <CloseIcon size="8px" strokeWidth="1.25" />
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

MemberCard.propTypes = {
  member: object.isRequired,
  isContactOpen: bool,
  openContactId: string,
  onContactToggle: func
};